export default __webpack_public_path__ + "static/media/chat.7ba9d2d1.gif";